export const FETCH_BRAND_INSTAGRAM_DETAILS_BEGIN = 'FETCH_BRAND_INSTAGRAM_DETAILS_BEGIN';
export const FETCH_BRAND_INSTAGRAM_DETAILS_SUCCESS = 'FETCH_BRAND_INSTAGRAM_DETAILS_SUCCESS';
export const FETCH_BRAND_INSTAGRAM_DETAILS_FAILURE = 'FETCH_BRAND_INSTAGRAM_DETAILS_FAILURE';
export const SHOW_IMAGE = 'SHOW_IMAGE';
export const RESET_BRAND_INSTAGRAM = 'RESET_BRAND_INSTAGRAM';
